import appApi from '../../../../../api/app-api';
import { ReportDropoutStudentType } from '../side-bar-filter/report-dropout-student.type';
import { DropoutStudent } from '../report-dropout-students';
import { toast } from 'react-toastify';
import { StudentDropOutReportDb } from '../../../../../api/types/reports/student-drop-out-report-db';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

const mapDropoutData = (data: StudentDropOutReportDb[]): DropoutStudent[] => {
  return data.map((item) => ({
    branch: item.branchName,
    firstName: item.firstName,
    lastName: item.lastName,
    id: item.nationalId,
    mobile: item.phoneNumber,
    email: item.email,
    program: item.abstractProgramName,
    annualSerialProgramNumber: item.annualSerialProgramNumber,
    startYear: item.programStartYear.toString(),
    dropoutDate: new Date(item.leftDate).toLocaleDateString('he-IL'),
  }));
};

export const getDropoutStudentOperation = async (
  filters: ReportDropoutStudentType,
  setDropoutData: (data: DropoutStudent[]) => any,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const response = await appApi.getDropoutStudentReport(filters);
    if (response.data.errCode) {
      toast.warn(displayErrorText(response.data.errCode));
      setLoading(false);
      return;
    }
    const body = response.data.body;
    setDropoutData(mapDropoutData(body));
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(
      `getDropoutStudentOperation is failed with the filters: ${JSON.stringify(filters)} and the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    throw e;
  }
};
